import { ItProjectsVariantsClient, type AvailableVariantDto } from "@lib/ShiOneClient";
import { ApiClientConfig } from "../../../../../auth/ApiClientConfig";

export const itProjectsVariantsClient = new ItProjectsVariantsClient(
    ApiClientConfig,
    import.meta.env.API_ENDPOINT,
);

export function fetchLinkedVariants(projectId: string): Promise<AvailableVariantDto[]> {
    return itProjectsVariantsClient.getLinkedVariants(projectId);
}
